import React, { useRef, useState } from 'react'

import { Form } from '../../../components/Form/Form'
import TextField from '../../../components/TextField/TextField'
import { post } from '../../../helpers/request'
import t from '../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const NewEventView = ({ history }) => {
  const [formValid, setFormValid] = useState(false)
  const createEventData = useRef({})

  const handleCreateEvent = () => {
    post('/soccer/competitions/events', createEventData.current)
      .then((response) => {
        history.push('/soccer/competitions')
      })
      .catch((error) => {
        // TODO: better error handling
        console.log(error)
      })
  }

  return (
    <div>
      <h3>{t('titles.Create_new_multi_competition_event')}</h3>
      <Form data={createEventData} onValidityChange={setFormValid}>
        <TextField
          name='name'
          label={t('labels.Name')}
          maxLength={100}
          minLength={2}
          required
        />
      </Form>
      <div>
        <button disabled={!formValid} onClick={handleCreateEvent}>
          {t('buttons.Create_event')}
        </button>
      </div>
    </div>
  )
}

export default withRouter(NewEventView)
